import * as ReduxThunk from 'redux-thunk';

import create from './create';
import * as Bixby from '$/core';
import { StaticDataService } from '$/services';

// Client/Admin
const newsEarningsFilters = create(
  () => StaticDataService.getNewsFilters(),
  'NEWS_EARNINGS_FILTERS_INPROGRESS',
  'NEWS_EARNINGS_FILTERS_SUCCESS',
  'NEWS_EARNINGS_FILTERS_FAILURE'
);
const getNewsFilters = newsEarningsFilters.get;
const newsFiltersReducer = newsEarningsFilters.reducer;

// Admin
const accountingTypes = create(
  () => StaticDataService.getAccountingTypes(),
  'ACCOUNTINGTYPES_LOADING',
  'ACCOUNTINGTYPES_SUCCESS',
  'ACCOUNTINGTYPES_FAILURE'
);
const getAccountingTypes = accountingTypes.get;
const accountingTypesReducer = accountingTypes.reducer;

const companyReportingTypes = create(
  () => StaticDataService.getCompanyReportingTypes(),
  'COMPANYREPORTINGTYPES_LOADING',
  'COMPANYREPORTINGTYPES_SUCCESS',
  'COMPANYREPORTINGTYPES_FAILURE'
);
const getCompanyReportingTypes = companyReportingTypes.get;
const companyReportingTypesReducer = companyReportingTypes.reducer;

const companyTransactionTypes = create(
  () => StaticDataService.getCompanyTransactionTypes(),
  'COMPANYTRANSACTIONTYPES_LOADING',
  'COMPANYTRANSACTIONTYPES_SUCCESS',
  'COMPANYTRANSACTIONTYPES_FAILURE'
);
const getCompanyTransactionTypes = companyTransactionTypes.get;
const companyTransactionTypesReducer = companyTransactionTypes.reducer;

const currencies = create(
  () => StaticDataService.getCurrencies(),
  'CURRENCIES_LOADING',
  'CURRENCIES_SUCCESS',
  'CURRENCIES_FAILURE'
);
const getCurrencies = currencies.get;
const currenciesReducer = currencies.reducer;

const dataSiteHosts = create(
  () => StaticDataService.getDataSiteHosts(),
  'DATASITEHOSTS_LOADING',
  'DATASITEHOSTS_SUCCESS',
  'DATASITEHOSTS_FAILURE'
);
const getDataSiteHosts = dataSiteHosts.get;
const dataSiteHostsReducer = dataSiteHosts.reducer;

const dataSiteProviders = create(
  () => StaticDataService.getDataSiteProviders(),
  'DATASITEPROVIDERS_LOADING',
  'DATASITEPROVIDERS_SUCCESS',
  'DATASITEPROVIDERS_FAILURE'
);
const getDataSiteProviders = dataSiteProviders.get;
const dataSiteProvidersReducer = dataSiteProviders.reducer;

const dataSiteStatus = create(
  () => StaticDataService.getDataSiteStatus(),
  'DATASITESTATUS_LOADING',
  'DATASITESTATUS_SUCCESS',
  'DATASITESTATUS_FAILURE'
);
const getDataSiteStatus = dataSiteStatus.get;
const dataSiteStatusReducer = dataSiteStatus.reducer;

const dataSiteTypes = create(
  () => StaticDataService.getDataSiteTypes(),
  'DATASITETYPES_LOADING',
  'DATASITETYPES_SUCCESS',
  'DATASITETYPES_FAILURE'
);
const getDataSiteTypes = dataSiteTypes.get;
const dataSiteTypesReducer = dataSiteTypes.reducer;

const debtIssuanceTypes = create(
  () => StaticDataService.getDebtIssuanceTypes(),
  'DEBTISSUANCETYPES_LOADING',
  'DEBTISSUANCETYPES_SUCCESS',
  'DEBTISSUANCETYPES_FAILURE'
);
const getDebtIssuanceTypes = debtIssuanceTypes.get;
const debtIssuanceTypesReducer = debtIssuanceTypes.reducer;

const industries = create(
  () => StaticDataService.getIndustries(),
  'INDUSTRIES_LOADING',
  'INDUSTRIES_SUCCESS',
  'INDUSTRIES_FAILURE'
);
const getIndustries = industries.get;
const industriesReducer = industries.reducer;

const industryGroups = create(
  () => StaticDataService.getIndustryGroups(),
  'INDUSTRYGROUPS_LOADING',
  'INDUSTRYGROUPS_SUCCESS',
  'INDUSTRYGROUPS_FAILURE'
);
const getIndustryGroups = industryGroups.get;
const industryGroupsReducer = industryGroups.reducer;

const sectors = create(() => StaticDataService.getSectors(), 'SECTORS_LOADING', 'SECTORS_SUCCESS', 'SECTORS_FAILURE');
const getSectors = sectors.get;
const sectorsReducer = sectors.reducer;

const subscriptions = create(
  () => StaticDataService.getSubscriptions(),
  'SUBSCRIPTIONS_LOADING',
  'SUBSCRIPTIONS_SUCCESS',
  'SUBSCRIPTIONS_FAILURE'
);
const getSubscriptions = subscriptions.get;
const subscriptionsReducer = subscriptions.reducer;

const userTitles = create(
  () => StaticDataService.getUserTitles(),
  'USERTITLES_LOADING',
  'USERTITLES_SUCCESS',
  'USERTITLES_FAILURE'
);
const getUserTitles = userTitles.get;
const userTitlesReducer = userTitles.reducer;

interface StaticDataState {
  accountingTypeState: ReturnType<typeof accountingTypesReducer>;
  currenciesState: ReturnType<typeof currenciesReducer>;
  dataSiteHostState: ReturnType<typeof dataSiteHostsReducer>;
  dataSiteProviderState: ReturnType<typeof dataSiteProvidersReducer>;
  dataSiteStatusState: ReturnType<typeof dataSiteStatusReducer>;
  dataSiteTypeState: ReturnType<typeof dataSiteTypesReducer>;
  debtIssuanceTypeState: ReturnType<typeof debtIssuanceTypesReducer>;
  industryState: ReturnType<typeof industriesReducer>;
  industryGroupState: ReturnType<typeof industryGroupsReducer>;
  newsFiltersState: ReturnType<typeof newsFiltersReducer>;
  companyReportingTypeState: ReturnType<typeof companyReportingTypesReducer>;
  companyTransactionTypeState: ReturnType<typeof companyTransactionTypesReducer>;
  sectorState: ReturnType<typeof sectorsReducer>;
  subscriptionState: ReturnType<typeof subscriptionsReducer>;
  userTitleState: ReturnType<typeof userTitlesReducer>;
}

const getAllStaticData =
  (): ReduxThunk.ThunkAction<Promise<void>, StaticDataState, null, Bixby.Models.BixbyAction> =>
  async (dispatch, getState) => {
    const state = getState();
    const toLoad: Array<Promise<void>> = [];

    if (!state.newsFiltersState || !state.newsFiltersState.data) {
      toLoad.push(dispatch(getNewsFilters()));
    }

    await Promise.all(toLoad);
  };

const getAllAdminStaticData =
  (): ReduxThunk.ThunkAction<Promise<void>, StaticDataState, null, Bixby.Models.BixbyAction> =>
  async (dispatch, getState) => {
    const state = getState();
    const toLoad: Array<Promise<void>> = [];

    if (!state.accountingTypeState || !state.accountingTypeState.data) {
      toLoad.push(dispatch(getAccountingTypes()));
    }
    if (!state.companyReportingTypeState || !state.companyReportingTypeState.data) {
      toLoad.push(dispatch(getCompanyReportingTypes()));
    }
    if (!state.companyTransactionTypeState || !state.companyTransactionTypeState.data) {
      toLoad.push(dispatch(getCompanyTransactionTypes()));
    }
    if (!state.currenciesState || !state.currenciesState.data) {
      toLoad.push(dispatch(getCurrencies()));
    }
    if (!state.dataSiteHostState || !state.dataSiteHostState.data) {
      toLoad.push(dispatch(getDataSiteHosts()));
    }
    if (!state.dataSiteProviderState || !state.dataSiteProviderState.data) {
      toLoad.push(dispatch(getDataSiteProviders()));
    }
    if (!state.dataSiteStatusState || !state.dataSiteStatusState.data) {
      toLoad.push(dispatch(getDataSiteStatus()));
    }
    if (!state.dataSiteTypeState || !state.dataSiteTypeState.data) {
      toLoad.push(dispatch(getDataSiteTypes()));
    }
    if (!state.debtIssuanceTypeState || !state.debtIssuanceTypeState.data) {
      toLoad.push(dispatch(getDebtIssuanceTypes()));
    }
    if (!state.industryGroupState || !state.industryGroupState.data) {
      toLoad.push(dispatch(getIndustryGroups()));
    }
    if (!state.industryState || !state.industryState.data) {
      toLoad.push(dispatch(getIndustries()));
    }
    if (!state.sectorState || !state.sectorState.data) {
      toLoad.push(dispatch(getSectors()));
    }
    if (!state.subscriptionState || !state.subscriptionState.data) {
      toLoad.push(dispatch(getSubscriptions()));
    }
    if (!state.userTitleState || !state.userTitleState.data) {
      toLoad.push(dispatch(getUserTitles()));
    }

    await Promise.all(toLoad);
  };

export {
  getAllStaticData,
  getAllAdminStaticData,
  accountingTypesReducer,
  companyReportingTypesReducer,
  companyTransactionTypesReducer,
  currenciesReducer,
  dataSiteHostsReducer,
  dataSiteProvidersReducer,
  dataSiteStatusReducer,
  dataSiteTypesReducer,
  debtIssuanceTypesReducer,
  industriesReducer,
  industryGroupsReducer,
  newsFiltersReducer,
  sectorsReducer,
  subscriptionsReducer,
  userTitlesReducer,
};
